<template>
  <div id="app">
    <nav v-if="isUserLoggedIn"> 
      <router-link to="/income">Pemasukan</router-link> |
      <router-link to="/expense">Pengeluaran</router-link> |
      <router-link to="/report">Laporan</router-link> |
      <router-link v-if="isAdmin" to="/admin/users" class="nav-item">Manajemen User</router-link><span v-if="isAdmin"> | </span>
      <a @click="logout" href="#">Logout</a>
    </nav>
    <nav v-else>
      <!-- <router-link to="/login">Login</router-link> -->
      <!-- <router-link to="/register">Register</router-link> -->
    </nav>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      isUserLoggedIn: localStorage.getItem('token') !== null // Inisialisasi dari localStorage
    };
  },
  computed: {
    // Atau bisa juga langsung dari localStorage jika tidak pakai Vuex
    isAdmin() {
      const user = JSON.parse(localStorage.getItem('user'));
      if (user) {
        try {
          return (user.role === 'admin' || user.role === 'owner');
        } catch (e) {
          console.error("Error decoding token for isAdmin check:", e);
          return false;
        }
      }
      return false;
    }
  },
  methods: {
    logout() {
      localStorage.removeItem('token'); // Hapus token
      this.isUserLoggedIn = false; // Perbarui status reaktif
      this.$router.push('/login'); // Redirect ke halaman login
    },
    // Metode untuk memperbarui status login dari komponen lain
    updateLoginStatus() {
      this.isUserLoggedIn = localStorage.getItem('token') !== null;
    }
  },
  // Tambahkan watcher pada rute untuk memastikan status diperbarui jika ada navigasi
  watch: {
    '$route'() {
      this.updateLoginStatus();
    }
  },
  // Jalankan saat komponen dibuat pertama kali
  created() {
    // Tambahkan listener untuk event custom (jika kita mau pakai event bus atau global event)
    // Atau bisa juga panggil updateLoginStatus di sini
    this.updateLoginStatus();
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

nav {
  margin-bottom: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
  text-decoration: none;
  padding: 10px 15px;
  cursor: pointer; /* Agar link logout terlihat seperti bisa diklik */
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
